import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  dialogContent: {
    padding: "8px 20px 14px"
  },
  contentText: {
    color: theme.palette.primary.dark,
    lineHeight: "19px",
    paddingBottom: 18,
    wordWrap: "break-word",
    "&.examEditInProgress": {
      color: theme.palette.primary.main
    }
  }
}));
